// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"e459d3a7","92":"a166ce68","99":"7040b02a","215":"907bf9d9","337":"99c7f156","443":"656960c6","453":"799eb653","479":"02298561","531":"f375b307","952":"0cfacb6a"}[chunkId] + ".chunk.js";
};